const selectorAnalyticsKeys = {
  "language-selector": "language selector",
  "location-selector": "location selector"
};
export {
  selectorAnalyticsKeys
};
